<!-- <div *ngIf="webSiteMode != 'PROD'" class="test-site-warning">
    {{ '::TestSiteWarning' | abpLocalization:'https://www.vaishnodevi.ca' }}
</div> -->
<abp-loader-bar></abp-loader-bar>
<abp-dynamic-layout></abp-dynamic-layout>
<div *ngIf="loading" class="loading-container flex-content-center">
    <div id="cover-spin"></div>
</div>
<p-toast></p-toast>